<template>
    <div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 class="text-2xl font-semibold text-gray-900">
                Settings
            </h1>
        </div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div class="bg-white overflow-hidden shadow rounded-lg mt-6">
                <div class="px-4 py-5 sm:p-6">
                    <apexo-button @click="enable2FA">
                        Enable 2FA
                    </apexo-button>

                    <apexo-input class="mt-6" v-model="otp" />

                    <apexo-button @click="challenge2FA">
                        Challenge 2FA
                    </apexo-button>

                    <apexo-button class="mt-6" @click="disable2FA">
                        Disable 2FA
                    </apexo-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApexoButton from '@/components/Elements/ApexoButton.vue';
    import ApexoInput from '@/components/Elements/ApexoInput.vue';

    export default {
        components: { ApexoButton, ApexoInput },

        data() {
            return {
                otp: '',
                qrCode: null,
                recoveryCode: null,
            };
        },

        methods: {
            async enable2FA() {
                await this.$axios.post('/user/two-factor-authentication');

                const qrCodeResponse = await this.$axios.get('/user/two-factor-qr-code');
                const recoveryCodesResponse = await this.$axios.get('/user/two-factor-recovery-codes');

                console.log(qr.data.svg);
                console.log(recoveryCodes);
            },

            async challenge2FA() {
                const response = await this.$axios.post('/two-factor-challenge', { code: this.otp });

                console.log(response);
            },

            disable2FA() {
                this.$axios.delete('/user/two-factor-authentication');
            },
        },
    };
</script>
